@if (viewRight) {
  <form [formGroup]="taxExemptForm" novalidate>
    <div class="mdlFildCont">
      <div class="row mb-3">
        <div class="col-md-4">
          <label>Reseller Permit # @if (isRequired('TaxIdentificationNumber')) {
            <span class="required"
            >*</span>
          }</label>
          <input type="text" class="form-control" min="0"
            maxlength="20" (keypress)="alphaNumerics($event)"
            formControlName="TaxIdentificationNumber">
            @if (taxExemptForm.get('TaxIdentificationNumber').errors  && (taxExemptForm.get('TaxIdentificationNumber').dirty || taxExemptForm.get('TaxIdentificationNumber').touched)) {
              <div class="alert alert-danger"
                >
                @if (taxExemptForm.get('TaxIdentificationNumber').errors.required) {
                  <span
                    i18n="@@TaxIdentificationNumber_required">
          Reseller Permit # is required</span>
                }
                @if (taxExemptForm.get('TaxIdentificationNumber').errors.whitespace) {
                  <span i18n="@@Invalid_input">
          Invalid
          input </span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label>
              Company@if (isRequired('CompanyName')) {
              <span class="required">
              *</span>
            }
          </label>
          <input type="text" class="form-control" formControlName="CompanyName" maxlength="50">
          @if (taxExemptForm.get('CompanyName').errors  && (taxExemptForm.get('CompanyName').dirty || taxExemptForm.get('CompanyName').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('CompanyName').errors.required) {
                <span>
                Company is required</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">
          <label>First Name @if (isRequired('FirstName')) {
            <span class="required">*</span>
          }</label>
          <input type="text" class="form-control" formControlName="FirstName" maxlength="50">
          @if (taxExemptForm.get('FirstName').errors  && (taxExemptForm.get('FirstName').dirty || taxExemptForm.get('FirstName').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('FirstName').errors.required) {
                <span i18n="@@FirstName_required">First
          Name is required</span>
              }
              @if (taxExemptForm.get('FirstName').errors.whitespace) {
                <span i18n="@@Invalid_input"> Invalid
          input </span>
              }
            </div>
          }
        </div>
        <div class="col-md-4 pt-3 pt-md-0">
          <label>Middle Name@if (isRequired('MiddleName')) {
            <span class="required">*</span>
          }</label>
          <input type="text" class="form-control" formControlName="MiddleName" maxlength="50">
          @if (taxExemptForm.get('MiddleName').errors  && (taxExemptForm.get('MiddleName').dirty || taxExemptForm.get('MiddleName').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('MiddleName').errors.required) {
                <span>Middle
                Name is required</span>
              }
              @if (taxExemptForm.get('MiddleName').errors.whitespace) {
                <span i18n="@@Invalid_input"> Invalid
          input </span>
              }
            </div>
          }
        </div>
        <div class="col-md-4 pt-3 pt-md-0">
          <label>Last Name @if (isRequired('LastName')) {
            <span class="required">*</span>
          }</label>
          <input type="text" class="form-control" formControlName="LastName" maxlength="50">
          @if (taxExemptForm.get('LastName').errors  && (taxExemptForm.get('LastName').dirty || taxExemptForm.get('LastName').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('LastName').errors.required) {
                <span i18n="@@LastName_required">Last Name
          is required</span>
              }
              @if (taxExemptForm.get('LastName').errors.whitespace) {
                <span i18n="@@Invalid_input"> Invalid
          input </span>
              }
            </div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-8">
          <label> Address@if (isRequired('Address')) {
            <span class="required">
            *</span>
          }</label>
          <textarea rows="3" class="form-control" formControlName="Address" maxlength="150"></textarea>
          @if (taxExemptForm.get('Address').errors  && (taxExemptForm.get('Address').dirty || taxExemptForm.get('Address').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('Address').errors.required) {
                <span>
                Address is required</span>
              }
            </div>
          }
        </div>
        <div class="col-md-4 pt-3 pt-md-0">
          <label>City@if (isRequired('City')) {
            <span class="required">
            *</span>
          }</label>
          <input type="text" class="form-control" formControlName="City" maxlength="30">
          @if (taxExemptForm.get('City').errors  && (taxExemptForm.get('City').dirty || taxExemptForm.get('City').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('City').errors.required) {
                <span>
                City is required</span>
              }
            </div>
          }
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-4">
          <label for="inputState" i18n="@@State">State@if (!emptyStateList && isRequired('State')) {
<span class="required">
          *</span>
}</label>
          <select id="inputState" class="form-select" formControlName="State">
            @if (!emptyStateList) {
              <option value="" selected>Select</option>
            }
            @if (emptyStateList) {
              <option value="0">--</option>
            }
            @for (st of stateList; track st) {
              <option [value]="st.Id">{{st.Name}}</option>
            }
          </select>
          @if (taxExemptForm.get('State').errors  && (taxExemptForm.get('State').dirty || taxExemptForm.get('State').touched)) {
            <div class="alert alert-danger"
              >
              @if (taxExemptForm.get('State').errors.required) {
                <span>
                State is required</span>
              }
            </div>
          }
        </div>
        <div class="col-md-4 pt-3 pt-md-0">
          <label for="">Zip Code @if (isRequired('Zip')) {
            <span class="required">
            *</span>
          }</label>
          <input type="text" min="0" class="form-control" (keypress)="alphaNumerics($event)"
            formControlName="Zip" maxlength="15">
            @if (taxExemptForm.get('Zip').errors  && (taxExemptForm.get('Zip').dirty || taxExemptForm.get('Zip').touched)) {
              <div class="alert alert-danger"
                >
                @if (taxExemptForm.get('Zip').errors.required) {
                  <span>
                  Zip Code is required</span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label>Country @if (isRequired('CountryId')) {
              <span class="required">
              *</span>
            }</label>
            <select id="inputcountry" class="form-control" formControlName="CountryId"
              (change)="onCountryChange($event.target.value)">
              <!-- <option value="" selected i18n="@@Select">Select</option> -->
              @for (ct of countryList; track ct) {
                <option [value]="ct.Id">{{ct.Name}}</option>
              }
            </select>
            @if (taxExemptForm.get('CountryId').errors  && (taxExemptForm.get('CountryId').dirty || taxExemptForm.get('CountryId').touched)) {
              <div class="alert alert-danger"
                >
                @if (taxExemptForm.get('CountryId').errors.required) {
                  <span>
                  Country is required</span>
                }
              </div>
            }
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Cell Phone @if (isRequired('CellPhoneCountryId')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <!-- <input class="form-control w-25 mr-3" type="text" > -->
                <select class="form-control" formControlName="CellPhoneCountryId">
                  @for (item of countryList; track item) {
                    <option [value]="item.Id">{{item.DialInCode}}</option>
                  }
                </select>
              </div>
              <!-- <input class="form-control w-50 mr-3" type="text"  formControlName="CellPhone"> -->
              <div class="homephone_numb_field">
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputCellPhone"
                  formControlName="CellPhone" cssClass="form-control p-0">
                </ejs-maskedtextbox>
              </div>
              @if (taxExemptForm.get('CellPhone').errors  && (taxExemptForm.get('CellPhone').dirty || taxExemptForm.get('CellPhone').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (taxExemptForm.get('CellPhone').errors.required) {
                    <span i18n="@@CellPhoneNumber_required">Cell
            Phone Number is required</span>
                  }
                  @if (taxExemptForm.get('CellPhone').errors.lessThanTen) {
                    <span>Enter 10 digit Cell Phone
                    Number</span>
                  }
                  @if (taxExemptForm.get('CellPhone').errors.whitespace) {
                    <span i18n="@@Invalid_input"> Invalid
            input </span>
                  }
                </div>
              }
              <div class="custom-control-without-label w-25 custom-checkbox" style="display: none">
                <input class="custom-control-input" id="SMS" name="SMS" type="checkbox">
                <label class="custom-control-label" for="SMS"><span class="ms-2">SMS</span></label>
              </div>
            </div>
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Home Phone@if (isRequired('HomePhone')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <!-- <input class="form-control w-25 mr-3" type="text"  formControlName="HomePhoneCountryId"> -->
                <select class="form-control" formControlName="HomePhoneCountryId">
                  @for (item of countryList; track item) {
                    <option [value]="item.Id">{{item.DialInCode}}</option>
                  }
                </select>
              </div>
              <!-- <input class="form-control w-75" type="text" formControlName="HomePhone"> -->
              <div class="homephone_numb_field">
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputHomePhone"
                  formControlName="HomePhone" cssClass="form-control p-0">
                </ejs-maskedtextbox>
              </div>
              @if (taxExemptForm.get('HomePhone').errors  && (taxExemptForm.get('HomePhone').dirty || taxExemptForm.get('HomePhone').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (taxExemptForm.get('HomePhone').errors.required) {
                    <span i18n="@@CellPhoneNumber_required">Home
            Phone Number is
            required</span>
                  }
                  @if (taxExemptForm.get('HomePhone').errors.lessThanTen) {
                    <span
                    i18n="@@CellPhoneNumber_required">Enter 10 digit Home Phone Number</span>
                  }
                  @if (taxExemptForm.get('HomePhone').errors.whitespace) {
                    <span i18n="@@Invalid_input"> Invalid
            input </span>
                  }
                </div>
              }
            </div>
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Work Phone @if (isRequired('WorkPhone')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <!-- <input class="form-control w-25 mr-3" type="text" formControlName="WorkPhoneCountryId"> -->
                <select class="form-control" formControlName="WorkPhoneCountryId">
                  @for (item of countryList; track item) {
                    <option [value]="item.Id">{{item.DialInCode}}</option>
                  }
                </select>
              </div>
              <!-- <input class="form-control w-75" type="text" formControlName="WorkPhone"> -->
              <div class="homephone_numb_field">
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputWorkPhone"
                  formControlName="WorkPhone" cssClass="form-control p-0">
                </ejs-maskedtextbox>
              </div>
              @if (taxExemptForm.get('WorkPhone').errors  && (taxExemptForm.get('WorkPhone').dirty || taxExemptForm.get('WorkPhone').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (taxExemptForm.get('WorkPhone').errors.required) {
                    <span i18n="@@CellPhoneNumber_required">Work
            Phone Number is
            required</span>
                  }
                  @if (taxExemptForm.get('WorkPhone').errors.lessThanTen) {
                    <span
                    i18n="@@CellPhoneNumber_required">Enter 10 digit work Phone Number</span>
                  }
                  @if (taxExemptForm.get('WorkPhone').errors.whitespace) {
                    <span i18n="@@Invalid_input"> Invalid
            input </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label for="">Email @if (isRequired('Email')) {
              <span class="required">*</span>
            }</label>
            <input type="text" class="form-control" formControlName="Email" maxlength="50">
            @if (taxExemptForm.get('Email').errors  && (taxExemptForm.get('Email').dirty || taxExemptForm.get('Email').touched ||
              taxExemptForm.get('Email').value !== '')) {
              <div class="alert alert-danger"
                >
                @if (taxExemptForm.get('Email').errors.pattern) {
                  <span i18n="@@Email_Error">
          Enter Valid E-Mail Ids separated by comma or semi colon
        </span>
                }
                @if (taxExemptForm.get('Email').errors.required) {
                  <span>
                  Email is required</span>
                }
                @if (taxExemptForm.get('Email').errors.maxlength) {
                  <span>Email can not contain more than 50 characters</span>
                }
              </div>
            }
          </div>
          <div class="col-md-4 pt-3 pt-md-0">
            <label for="">Fax @if (isRequired('Fax')) {
              <span class="required">*</span>
            }</label>
            <div class="form-group mb-0">
              <div class="phone_code">
                <!-- <input class="form-control w-25 mr-3" type="text" formControlName="FaxCountryId"> -->
                <select class="form-control" formControlName="FaxCountryId">
                  @for (item of countryList; track item) {
                    <option [value]="item.Id">{{item.DialInCode}}</option>
                  }
                </select>
              </div>
              <div class="homephone_numb_field">
                <!-- <input class="form-control w-75" type="text" formControlName="Fax"> -->
                <ejs-maskedtextbox [mask]="PhoneNumberMask" name="phone" id="inputFax" formControlName="Fax"
                  cssClass="form-control p-0">
                </ejs-maskedtextbox>
              </div>
              @if (taxExemptForm.get('Fax').errors  && (taxExemptForm.get('Fax').dirty || taxExemptForm.get('Fax').touched)) {
                <div class="alert alert-danger"
                  >
                  @if (taxExemptForm.get('Fax').errors.required) {
                    <span>
                    Fax is required</span>
                  }
                  @if (taxExemptForm.get('WorkPhone').errors.lessThanTen) {
                    <span
                    i18n="@@CellPhoneNumber_required">Enter 10 digit work Phone Number</span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  }

  @if (!viewRight) {
    <div class="text-center mt-5 pt-5" style="text-align: center; font-size:13px">
      <div class="alert alert-info mb-5">
        {{viewRightFalseMessage}}
      </div>
    </div>
  }

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal"
    (click)="cancelForm(discardPopup)">Cancel</button>
    <div class="button_tooltip">
      <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="!taxExemptForm.valid || !editRight"
      (click)="saveTaxExempt()">Save</button>
      @if (!editRight) {
        <div class="button_tooltip_modal" style="left:28%">
          @if (!editRight) {
            <p class="mb-0">{{editRightFalseMessage}}</p>
          }
          <i class="fa fa-caret-down .text-dark h2 butt_downIcon" aria-hidden="true"></i>
        </div>
      }
    </div>

  </div>



  <ng-template #discardPopup>
    <div class="modal-header">
      <h5 class="modal-title pull-left" i18n="@@Confirm">Confirm</h5>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body ptb24">
      <p class="m-0" i18n="@@Sure_discard" i18n="@@sure_discard">
      Are you sure you want to cancel? Any data modifications will not be saved
    </p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-primary me-3" type="button" data-bs-toggle="modal" data-bs-target="#taxFreeModal"
      (click)="modalRef.hide();" i18n="@@No">No</button>
      <button class="btn btn-primary" type="button" data-bs-dismiss="modal" (click)="clearForm()" i18n="@@Yes">Yes</button>
    </div>
  </ng-template>